/**
 * src/services/shareBus.js — tiny same-tab pub/sub (+ cross-tab broadcast)
 * that lets screens push frames to the HOST's ShareModal without prop
 * drilling (T12). Mirrors the SharedWorker-style contract.
 *
 * Terminology: HOST / Viewer-Guest — 'Lead' stays reserved for the bot concept.
 */

const CHANNEL_NAME = 'bcc-share-bus';
let listeners = [];

const bc = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(CHANNEL_NAME) : null;

if (bc) {
  bc.onmessage = (event) => {
    if (event?.data?.type === 'bcc-share-frame') {
      for (const fn of listeners) fn(event.data.frame);
    }
  };
}

/** Screens call this whenever their shareable state changes. */
export function emitShareFrame(frame) {
  if (bc) bc.postMessage({ type: 'bcc-share-frame', frame });
  for (const fn of listeners) fn(frame);
}

/** ShareModal subscribes while a share is active; returns unsubscribe. */
export function onShareFrame(fn) {
  listeners.push(fn);
  return () => {
    listeners = listeners.filter((item) => item !== fn);
  };
}
